import { SlateLayout } from '@tribeplatform/react-components/LayoutFrame'

export const getSlateLayoutFromString = (layout: string): SlateLayout => {
  const slateLayout = layout as SlateLayout
  if (Object.values(SlateLayout).includes(slateLayout)) {
    return slateLayout
  }

  return null
}
